<template>
  <div class="footer-wrapper">
    <div class="privacy-footer">
        <a href="https://www.schools.nyc.gov/privacy" target="_blank">Privacy Policy and Terms of Use</a>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
})
export default class PrivacyFooter extends Vue {
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.privacy-footer {
  font-size: 12px;
  width: 100%;
  text-align: right;
  position: absolute;
  bottom: -25px;
  padding: 0px;
  >a {
    text-decoration: none;
  }
  @media print {
    display: none !important;
  }
}
.footer-wrapper {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/PrivacyFooter.vue